import "./App.css";
import { mainRoutes } from "./Features/routes";
import { useRoutes } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-notifications/lib/notifications.css";
import "tippy.js/dist/tippy.css";
function App() {
  const renderRoutes = useRoutes(mainRoutes);
  return (
    <div className="App">
      <>{renderRoutes}</>
      <NotificationContainer />
    </div>
  );
}
export default App;
